<template>
  <div v-if="type === 'avatar'" class="fileinput text-center">
    <label class="avatar-upload" :title="hasImage ? changeText : selectText">
      <img v-if="hasImage || placeholder" :src="image" alt="Profile photo" />
      <span v-else class="avatar-upload__empty">
        <i class="tim-icons icon-single-02"></i>
      </span>
      <span class="avatar-upload__overlay">
        <i class="tim-icons icon-camera-18"></i>
        <span class="avatar-upload__overlay-text">{{ hasImage ? changeText : selectText }}</span>
      </span>
      <input
        accept="image/*"
        @change="handlePreview"
        type="file"
        :multiple="false"
        class="avatar-upload__input"
        aria-label="Upload profile photo"
      />
    </label>
    <div v-if="fileExists">
      <a href="#" class="avatar-upload__remove" @click.prevent="removeFile">{{ removeText }}</a>
    </div>
  </div>
  <div v-else class="fileinput text-center">
    <div class="fileinput-new thumbnail">
      <img :src="image" alt="preview" />
    </div>
    <div>
      <span class="btn btn-primary btn-sm btn-simple btn-file">
        <span class="fileinput-new">{{
          fileExists ? changeText : selectText
        }}</span>
        <input type="hidden" value="" name="" />
        <input
          accept="image/*"
          @change="handlePreview"
          type="file"
          name="..."
          class="valid"
          :multiple="false"
          aria-invalid="false"
        />
      </span>
      <base-button size="sm" v-if="fileExists" icon class="ml-2" @click="removeFile" type="danger">
        <i class="fas fa-times"></i>
      </base-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'image-upload',
  props: {
    type: {
      type: String,
      default: '',
      description: 'Image upload type (""|avatar)'
    },
    src: {
      type: String,
      default: '',
      description: 'Initial image to display'
    },
    selectText: {
      type: String,
      default: 'Select image'
    },
    changeText: {
      type: String,
      default: 'Change'
    },
    removeText: {
      type: String,
      default: 'Remove'
    },
    placeholder: {
      type: String,
      default: '',
      description: 'Override for the empty-state image'
    }
  },
  data() {
    return {
      imagePreview: null
    };
  },
  computed: {
    fileExists() {
      return this.imagePreview !== null;
    },
    hasImage() {
      return !!(this.imagePreview || this.src);
    },
    defaultPlaceholder() {
      return this.type === 'avatar'
        ? 'https://console.offthecouch.io/img/placeholder.jpg'
        : 'https://console.offthecouch.io/img/image_placeholder.jpg';
    },
    image() {
      return this.imagePreview || this.src || this.placeholder || this.defaultPlaceholder;
    }
  },
  methods: {
    handlePreview(event) {
      let file = event.target.files[0];
      this.imagePreview = URL.createObjectURL(file);
      this.$emit('change', file);
    },
    removeFile() {
      this.imagePreview = null;
      this.$emit('change', null);
    }
  }
};
</script>
<style scoped>
.avatar-upload {
  position: relative;
  display: inline-block;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 0;
  border: 2px solid rgba(225, 78, 202, 0.35);
}

.avatar-upload img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar-upload__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(125, 125, 125, 0.12);
  color: rgba(255, 255, 255, 0.45);
  font-size: 3rem;
}

.white-content .avatar-upload__empty {
  color: rgba(0, 0, 0, 0.35);
}

.avatar-upload__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s;
}

.avatar-upload:hover .avatar-upload__overlay,
.avatar-upload:focus-within .avatar-upload__overlay {
  opacity: 1;
}

.avatar-upload__overlay i {
  font-size: 1.25rem;
}

.avatar-upload__overlay-text {
  font-size: 11px;
  font-weight: 600;
}

.avatar-upload__input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.avatar-upload__remove {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.avatar-upload__remove:hover {
  color: #fd5d93;
}

.white-content .avatar-upload__remove {
  color: rgba(0, 0, 0, 0.5);
}
</style>
